import React, {useState} from 'react';
import styled from "styled-components";
import SubSearchDrawer from "./sub/SubSearchDrawer";

/**
 * `드로어
 * */
export const DrawerTriger = styled.button`
  cursor: pointer;
  border: 1px solid #d0d0d0;
  line-height: 30px;
  padding: 0 15px;
  text-align: center;
  height: 30px;
  margin-right: 5px;
`;


export const Label = styled.span`
  margin-right: 10px;
  line-height: 28px;
  font-weight: bold;
`;


/**
 * title: 조건 이름
 * target: 실제 검색의 키
 * setSearchObject: 검색조건 설정 메서드
 * codeIdx: 전체 코드 중에서 현재 드로어 에서 보여줄 코드들의 상위 부모키
 * */

function SearchDrawerOpener({title, data, target, returnData, codeIdx}) {
    const [label, setLabel] =useState('선택');
    const [slideIn, setSlideIn] =useState(false);
    const openDrawer =()=>{
        setSlideIn(true);
    }

    return (
        <div className={"m-3"}>
            <Label> {title} :</Label>
            {/*선택한 코드의 계층명을 가져오는 로직은 개선이 필요해 보임*/}
            <DrawerTriger onClick={openDrawer}>{label}</DrawerTriger>
            <div className={`drawer-background ${slideIn ? 'show' : 'none'}`} onClick={()=>setSlideIn(false)}></div>
            <SubSearchDrawer
                title={title} data={data} target={target} returnData={returnData}
                slided={{slideIn:slideIn, setSlideIn:setSlideIn}} width={30}
                codeIdx={codeIdx} labeled={{label:label, setLabel:setLabel}}/>
        </div>

    );
}

export default SearchDrawerOpener;
